<template>
    <div>
        <h2>Hello Institute More</h2>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>